import {Injectable} from '@angular/core';
import {of, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {UiConfigService} from '../../lib-core';
import {SanitizationService} from './sanitization.service';
import {UiVorgang} from '../models/uiVorgang';
import {catchError, filter, switchMap, tap} from 'rxjs/operators';
import {EventService} from './event.service';
import {flatMap, UIArtefakt, UIArtefaktContainer, UIContainerControl, UiVorgangReferenzControl} from '../models/uiArtefakt';
import {UiControl} from '../models/uiControl';


export interface VorgangReferenzBeitragBox {
  uiVorgangReferenz: UiVorgangReferenzControl;
  index: number;
}

@Injectable({
  providedIn: 'root'
})
export class CalculationService {
  public asyncBerechnungSubject$= new Subject<UiControl>();

  constructor(private _http: HttpClient, private _uiConfigService: UiConfigService,
              private _sanitizer: SanitizationService, private _eventService: EventService) {
    this.asyncBerechnungSubject$.pipe(
        filter(uiControl => !!uiControl?.uiVorgang?.UIArtefakt?.length),
        filter(uiControl => !!this.getVorgangReferenzArtefaktFromBeitragBox(this.getBeitragBoxArtefakt(uiControl))),
        switchMap(uiControl => {
          const uiVorgangIDArtefakt =
              this.getVorgangReferenzArtefaktFromBeitragBox(this.getBeitragBoxArtefakt(uiControl))?.uiVorgangReferenz;
          return this._http.post<UiVorgang>(this._uiConfigService.getAntragserfassungUrl() +
            '/api/produkt/uivorgang/' + uiVorgangIDArtefakt.UIVorgangID, this._sanitizer.sanitize(uiControl)).pipe(
              tap(uiVorgang => this._eventService.asyncBerechnung$.next(uiVorgang)),
              catchError(err => {
                if (!!console?.log) {
                  console?.log(err);
                }
                return of(null);
              })
            );
        })
    ).subscribe();
  }

  public getVorgangReferenzArtefaktFromBeitragBox(beitragBox: UIArtefaktContainer): VorgangReferenzBeitragBox {
    let result;
    beitragBox?.UIArtefakt.forEach((artefakt, index) => {
        if (!!((artefakt as UiVorgangReferenzControl).UIVorgangID) &&
        (artefakt as UiVorgangReferenzControl).UIVorgangID.indexOf('AusgabewertAsynchron') >= 0) {
          result = {} as VorgangReferenzBeitragBox;
          result.uiVorgangReferenz = artefakt as UiVorgangReferenzControl;
          result.index = index;
      }
    });
    return result;
  }

  private getBeitragBoxArtefakt(uiControl: UiControl): UIArtefakt {
    return flatMap(uiControl.uiVorgang.UIArtefakt)
        .filter(artefakt => artefakt.UIArtefakttyp === 'UIContainer')
        .filter(artefakt => 'BeitragBox' === (artefakt as UIContainerControl).UIContainerComponent)[0];
  }
}
